'use strict';

/**
 * Creates a key of `channel:topic`.
 *
 * @param {string} channel
 * @param {string} topic
 * @returns {string}
 */
function toKey(channel, topic) {
  return "".concat(channel, ":").concat(topic);
}
exports.toKey = toKey;
